// @owners { team: patients-team }
import { type PlansEndpointConfirmRequest } from '@alto/scriptdash/alto/med_sync/patients/v1/plans_endpoint';
import { put } from '~shared/helpers/apiHelper';
import { useMutation } from '~shared/react-query';

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
const confirmPlan = async ({ id }: PlansEndpointConfirmRequest) => {
  return await put(
    `/med_sync/plans/confirm`,
    {
      id,
    },
    {
      version: 'v1',
    },
  );
};

export const CONFIRM_PLAN_MUTATION_KEY = ['confirmPlan'];

/**
 * @deprecated prefer using auto-generated endpoints directly with `apiEndpointHandler`
 * @see https://github.com/scriptdash/clients/pull/7913
 */
export const useConfirmPlan = () => {
  return useMutation({ mutationFn: confirmPlan, mutationKey: CONFIRM_PLAN_MUTATION_KEY });
};
